import * as types from "../actions/actionTypes";
import initialState from "./initialState";

export const services = (state = initialState.services, action) => {
  switch (action.type) {
    case types.LOAD_SERVICE_SUCCESS:
      return action.services;

    case types.CREATE_SERVICE_SUCCESS:
      return [...state, { ...action.service }];

    case types.UPDATE_SERVICE_SUCCESS:
      return [
        ...state.filter((s) => s.id !== action.service.id),
        { ...action.service }
      ];

    default:
      return state;
  }
};

export const service = (state = initialState.service, action) => {
  switch (action.type) {
    case types.GET_SERVICE_SUCCESS:
      return action.service;

    default:
      return state;
  }
};

export const savingService = (state = initialState.savingService, action) => {
  switch (action.type) {
    case types.SAVING_SERVICE:
      return action.savingService;

    default:
      return state;
  }
};

export const serviceToDelete = (
  state = initialState.serviceToDelete,
  action
) => {
  switch (action.type) {
    case types.REQUEST_SERVICE_ID:
      return action.serviceToDelete;

    default:
      return state;
  }
};
